import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/content.css";
import "./styles/searchResult.css";
import "./styles/pageControllor.css";
import "./styles/chart.css";
import "./styles/search.css";
import "./styles/homeChart.css";
import "./styles/loading.css";
import "./styles/main.css";
import "./styles/footer.css";
import "./styles/nav.css";
import "./styles/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
